<template>
  <v-container class="pa-0 ma-0 academics-page">
    <h1 class="show-title mb-10">{{ content.title }}</h1>

    <v-row>
      <v-col
        v-for="(item, i) in $t('spinoffs').items"
        :key="i"
        class="col-12 col-md-6 col-lg-6 pt-0 px-5 pb-10"
      >
        <RecognizedSpinOffCard :content="item" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RecognizedSpinOffCard from '@/components/RecognizedSpinOffCard'

export default {
  name: 'SpinoffList',
  components: { RecognizedSpinOffCard },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
